import { z } from 'zod/v4'

export const hotkeySchema = z.object({
  commandId: z.string(),
  hotkey: z.string(),
  label: z.string(),
})

export type CommandHotkey = z.infer<typeof hotkeySchema>
